import axios from 'axios'
import { branchUrl, getHeader } from '@/config'

const state = {
  branchList: []
}

const mutations = {
  SET_BRANCH_LIST (state, obj) {
    state.branchList = obj
  }
}

const actions = {
  getBranchList: ({ commit }) => {
    axios.get(branchUrl, { headers: getHeader() })
      .then(response => {
        commit('SET_BRANCH_LIST', response.data.data)
      })
  }
}

export default {
  state, mutations, actions
}
